
import { notification } from "antd";
import * as libCon from "../community-hats-js-library/Constants.js";
import { getCurrentI18n, translationExists } from "../hooks/LanguageHooks";

/**
 * Resolves whatever a call site passed into text for the current locale.
 *
 * Call sites pass three different things: a catalogue key, a library status
 * constant (libCon.NETWORK_ERROR and friends, which the dashboard used to show
 * to the user raw), or an already built string. Only the first two are
 * translated; anything else is shown untouched.
 */
export const resolveMessage = (message) => {
    const i18n = getCurrentI18n();

    if (message in libCon.ERRORS) {
        const error = libCon.ERRORS[message];
        return `${i18n.t(error[libCon.MESSAGE])} (${i18n.t('code')}: ${error[libCon.CODE]})`;
    }

    return translationExists(i18n, message) ? i18n.t(message) : message;
}

export const showNotification = (message) => {
    notification.open({
        message: resolveMessage(message),
        showProgress: true,
        pauseOnHover: true,
        placement: "top",
        duration: 6,
        style: {
            background: "var(--background-color-1-transparent)"
        }
    })

}

export const showError = (message) => {
    notification.open({
        message: resolveMessage(message),
        showProgress: true,
        pauseOnHover: true,
        placement: "top",
        style: {
            background: "var(--primary-color-2-transparent)"
        }
    })


}

export const getSensorBrandColor = (brand) => {
    switch (brand) {
        case libCon.GOVEE:
            return ("var(--chart-color-1)");
        case libCon.KESTREL:
            return ("var(--chart-color-6)");
        case libCon.HOBO:
            return ("var(--chart-color-8)");
        default:
            return ("var(--chart-color-9)");

    }
}